import { NavLink } from "react-router-dom";

const items = [
  ["/home", "fa-house", "Home"],
  ["/protein-shakes", "fa-glass-water", "Shakes"],
  ["/deliveries", "fa-box", "Deliveries"],
  ["/notifications", "fa-bell", "Alerts"],
  ["/profile", "fa-user", "Profile"],
];

export default function BottomNav() {
  return (
    <nav className="bottom-nav">
      {items.map(([to, icon, label]) => (
        <NavLink key={to} to={to}>
          <i className={`fa-solid ${icon}`} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
